module.exports = __webpack_public_path__ + "static/media/avatar.f17404b4.svg";